import React, { useState, useEffect } from 'react';
import { Building2, Menu, X, MessageCircle } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md py-4' : 'bg-transparent py-6'
    }`}>
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center">
            <Building2 className="h-8 w-8 text-blue-700 mr-3" />
            <span className="font-bold text-2xl text-blue-800">ImóvelIA</span>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-10">
            <button 
              onClick={() => scrollToSection('como-funciona')} 
              className="font-medium text-slate-700 hover:text-blue-700 transition-colors py-2"
            >
              Como Funciona
            </button>
            
            <a 
              href="/correspondente-bancario" 
              className="font-medium text-slate-700 hover:text-blue-700 transition-colors py-2"
            >
              Correspondente Bancário
            </a>
            
            <div className="flex items-center space-x-6">
              <button 
                onClick={() => scrollToSection('precos')} 
                className="font-medium text-slate-700 hover:text-blue-700 transition-colors py-2"
              >
                Preços
              </button>
              <button 
                onClick={() => scrollToSection('faq')} 
                className="font-medium text-slate-700 hover:text-blue-700 transition-colors py-2"
              >
                FAQ
              </button>
            </div>
          </nav>
          
          {/* Action Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="https://pay.kiwify.com.br/cSvs3ux"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-full font-medium transition-colors"
            >
              Assinar Agora
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t shadow-lg">
          <div className="container mx-auto px-4 py-6 space-y-4">
            <button 
              onClick={() => scrollToSection('como-funciona')} 
              className="block w-full text-left py-3 text-slate-700 hover:text-blue-700 transition-colors border-b border-slate-100"
            >
              Como Funciona
            </button>
            
            <div className="space-y-3">
              <p className="text-sm font-semibold text-slate-500 uppercase tracking-wide">Especialidades</p>
              <a 
                href="/correspondente-bancario" 
                className="block py-2 text-slate-700 hover:text-blue-700 transition-colors pl-4"
              >
                Correspondente Bancário
              </a>
            </div>
            
            <div className="border-t border-slate-100 pt-4 space-y-3">
              <button 
                onClick={() => scrollToSection('precos')} 
                className="block w-full text-left py-2 text-slate-700 hover:text-blue-700 transition-colors"
              >
                Preços
              </button>
              <button 
                onClick={() => scrollToSection('faq')} 
                className="block w-full text-left py-2 text-slate-700 hover:text-blue-700 transition-colors"
              >
                FAQ
              </button>
            </div>
            
            <div className="border-t border-slate-100 pt-4 space-y-3">
              <a
                href="https://pay.kiwify.com.br/cSvs3ux"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors w-full"
              >
                Assinar Agora
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;